import { Stack, Typography } from '@mui/material';
import { DialogComponentProps, useDialog } from 'common/hooks/useDialog';
import { format } from 'date-fns';
import { sk } from 'date-fns/locale';
import { FilterOperator, ReportType, SortDirection, useReportsQuery } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FinoptioReportIcon } from '../../../assets/icons/FinoptioReportIcon.svg';
import { ReportWidget } from '../ReportWidget/ReportWidget';
import { FinoptioReportIntroDialog } from './FinoptioReportIntroDialog/FinoptioReportIntroDialog';

export const FinoptioReportWidget: React.FC = () => {
  const { t } = useTranslation();

  const { data } = useReportsQuery({
    variables: {
      filterInput: {
        arguments: [
          {
            filterCondition: {
              fieldPath: 'type',
              operator: FilterOperator.Equal,
              values: [ReportType.Finoptio],
            },
          },
        ],
      },
      sortInput: { by: [{ direction: SortDirection.Desc, fieldPath: 'creationTimestamp' }] },
    },
  });

  const updateDate = data?.reports.items?.[0]?.creationTimestamp;

  const finoptioReportIntroDialog = useDialog<DialogComponentProps<void>, void>(FinoptioReportIntroDialog, {
    instanceId: 'finoptio-report-intro-dialog',
    navigable: true,
  });

  const handleShowFinoptioReportIntroDialog = () => {
    finoptioReportIntroDialog.create({});
  };

  return (
    <ReportWidget onClick={handleShowFinoptioReportIntroDialog}>
      <Stack direction="row" gap={2}>
        <FinoptioReportIcon />
        <Stack>
          <Typography variant="bodyStrongL"> {t('finoptioReport.widget.title')}</Typography>
          <Typography variant="bodyM">
            {updateDate
              ? t('finoptioReport.widget.updateDate', { date: format(updateDate, 'dd. MMMM', { locale: sk }) })
              : t('finoptioReport.widget.subtitle')}
          </Typography>
        </Stack>
      </Stack>
    </ReportWidget>
  );
};
